<template>
  <div>
    <el-dialog width="500px" :before-close="handleClose" :visible.sync="mydialogFormVisible">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>{{title}}</div>
      </div>
      <el-form :model="myform" ref="myform" :validate-on-rule-change="false" :rules="rules">
        <el-form-item :label="label[0] + ':'" label-width="90px" prop="one">
          <el-input v-model="myform.one" maxlength="40" placeholder="必填，2-40个字"></el-input>
        </el-form-item>
        <el-form-item :label="label[1] + ':'" label-width="90px" prop="two">
          <el-input-number v-model="myform.two" :step="1" :min="0" :max="10" label="描述文字"></el-input-number>
          <div style="color: rgb(215, 76, 76);font-size: 10px;line-height: 20px;">Tip:数字越大越靠前</div>      
        </el-form-item>
        <el-form-item v-if="needStatus" :label="label[2] + ':'" label-width="90px" prop="three">
          <el-radio-group v-model="myform.three">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="quit">取 消</el-button>
        <el-button v-if="!isClick" :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}" type="primary" @click="submit('myform')">提 交</el-button>
        <el-button v-else type="primary" :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}" disabled>提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {
  list
} from "@/api/labelClass";
export default {
    props:{
        title:{
            type:String,
            default:'编辑'
        },
        myform: Object,
        needStatus:Boolean,
        // rules:Object,
        dialogFormVisible:Boolean,
        label:Array
    },
    watch:{
      dialogFormVisible:{
       deep: true,
       handler(v) {
          this.mydialogFormVisible = v
       }
      }
    },
    data(){
        return {
          isClick:false,
          classList:[],

          mydialogFormVisible:this.dialogFormVisible,
          rules: {
            one: [
              { required: true, message: '请输入内容', trigger: 'change' },
              { min: 2, max: 40, message: '长度在 2 到 40 个字符', trigger: 'blur' }
            ],
            two: [
              { required: true, message: '请填写排序', trigger: 'change' },
              
            ]
          }
        }
    },
    methods:{
        ...mapActions(["setDialogFormVisible"]),
        handleClose(){
          this.$refs['myform'].clearValidate();
          this.mydialogFormVisible = false
          this.$emit('changedialogFormVisible',this.mydialogFormVisible)
          this.setDialogFormVisible(false)
        },
        quit(){
          this.$refs['myform'].clearValidate();
          this.mydialogFormVisible = false
          this.$emit('changedialogFormVisible',this.mydialogFormVisible)
          this.setDialogFormVisible(false)

        },
        submit(myform){
          this.$refs[myform].validate((valid) => {
            if (valid) {
              this.$confirm('是否确定提交?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
              }).then(() => {
                this.isClick = true
                setTimeout(() => {
                  this.isClick = false
                }, 2000);
                
                this.$emit('dialogSubmit',this.myform)
                this.mydialogFormVisible = false
                this.$emit('changedialogFormVisible',this.mydialogFormVisible)
                this.setDialogFormVisible(false)
                this.$refs.myform.resetFields();
              }).catch(() => {
                this.$message({type: "error",message: "提交出现错误，请重新发起！"})          
              });
            } else {
              this.$message({
                  type: 'info',
                  message: '请正确填写！'
                });   
              return false;
            }
          });
          
          
        },
        changeX(e){
          // console.log(e)
          this.$forceUpdate()
        },

        //获取分类列表
      async getListAsync () {
        let { status, data, message, errors } = await list({pageSize:200});
        if (status) {
          data.forEach(e => {
            this.classList.push({
              value:e.name,
              label:e.name
            })
          })
        } else {
          let errortext = ''
          for (const key in errors) {
            errortext += errors[key]
          }
          this.$message.error({ message: message + errortext });
        }
      }
    },
    created(){
      // this.getListAsync()
    },
    mounted(){
      
    }
}
</script>
<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
::v-deep .el-form-item__label{
  font-weight: 600;
}

</style>